(function ($, once) {
  'use strict';

  /**
   * Retrieves the total of inputs that has a value.
   *
   * @returns {number}
   *   The count.
   */
  $.fn.filledInputsCount = function () {
    let count = 0;
    const $inputs = $(this).find('.form-item :input');

    if ($inputs.length) {
      $inputs.each(function () {
        const $input = $(this);
        const type = $input.prop('type');
        const value = $input.val();

        if (type === 'checkbox') {
          if ($input.prop('checked')) {
            count++;
          }
        }
        else if (value && value.length) {
          count++;
        }
      });
    }

    return count;
  };

  // Stop CSS transitions from firing on page load.
  Drupal.behaviors.preloader = {
    attach: function (context, settings) {
      $('body', context).removeClass('preload');
    }
  };

  Drupal.behaviors.themeJS = {
    attach: function (context, settings) {
      if (typeof context['location'] !== 'undefined') { // Only fire on document load.
        $(document).on('change', '.password-field', function () {
          $('.form-item-current-pass').fadeIn().css('display', 'grid');
        });

        $(document).on('click', '#edit-searchboxlabel', function (e) {
          if ($('#edit-searchbox').val() !== '') {
            e.preventDefault();
            $(this).parents('form').submit();
          }
        });
      }
    }
  };

  // Hide the submit button when js is loaded in the division form.
  Drupal.behaviors.divisionSwitcher = {
    attach: function (context, settings) {
      $('form.division-form').find('.form-submit').hide();
    }
  };

  // Toggles the main menu.
  Drupal.behaviors.mainMenu = {
    attach: function (context, settings) {
      let state = localStorage.getItem('state');

      function toggleMenu(page, menuBlock) {
        page.toggleClass('sidebar-collapsed');
        menuBlock.toggleClass('collapsed');
        menuBlock.find('button.hamburger').toggleClass('is-active');
      }

      $(once('mainMenu', '.menu-block .menu-toggle', context)).each(function (i) {
        let page = $('.page-standard');
        let menuBlock = $(this).parent('.menu-block');
        if (state === null) {
          toggleMenu(page, menuBlock);
          localStorage.setItem('state', 'true');
        } else if (state === 'true') {
          toggleMenu(page, menuBlock);
        }

        $(this).on('click', function () {
          toggleMenu(page, menuBlock);
          if (state === 'true') {
            localStorage.setItem('state', 'false');
          }
          else {
            localStorage.setItem('state', 'true');
          }
        });
      });
    }
  };

  // Initialize the overlay scrollbars library.
  Drupal.behaviors.overlayScrollbars = {
    attach: function (context, settings) {
      OverlayScrollbars(document.querySelectorAll('[data-overlay-scrollbar]'), {});
      OverlayScrollbars(document.querySelectorAll('.dialog-off-canvas-main-canvas, .menu-block .menu-content'), {
        overflowBehavior: {
          x: 'hidden',
        },
      });
    }
  };

  // Scroll to table or tabs when sorting table.
  Drupal.behaviors.indiciaTabSelectors = {
    attach: function (context, settings) {
      const $tableSorts = $('table a[href*=sort]');

      if ($tableSorts.length) {
        let anchor = '#tabs';
        const $anchor = $('.sedico-main-table-anchor', context);

        if ($anchor.length) {
          anchor = '#' + $anchor.attr('id');
        }

        $tableSorts.each(function () {
          $(this).attr('href', $(this).attr('href') + anchor);
        });
      }
    }
  };

  Drupal.behaviors.indiciaScrollableTableHeight = {
    attach: function (context) {
      const $table = $('.sedico-main-table .table-scrollable', context);
      if ($table.length) {
        const tableY = Math.round($table.offset().top);
        const heightCalculation = tableY + 120;
        $table.css('height', 'calc(100vh - ' + heightCalculation + 'px)');
      }
    }
  }

  Drupal.behaviors.indiciaFilterForm = {
    attach: function (context, settings) {
      const $toggles = $('.filter-form-toggle', context);

      if ($toggles.length) {
        $(once('indiciaFilterForm', $toggles)).each(function () {
          const $toggle = $(this);
          const $filters = $toggle.siblings('.filter-form');

          if ($filters.length && $filters.find('form').length) {
            // Overlay and modal toggle.
            const $overlay = $('<span>').addClass('overlay');
            $('body')
              .append($overlay)
              .append($filters);


            $toggle.add($overlay).click(function () {
              $filters.toggleClass('active');
              $overlay.toggleClass('active');
            });

            // Update count of filters.
            const $filterInputs = $filters.find('.form-item :input');
            if ($filterInputs.length) {
              const $formTitleCount = $filters.find('.filter-form-title .count');
              const $count = $toggle.find('.count').add($formTitleCount);

              // Update count on load.
              $count.add().text($filters.filledInputsCount());

              // Update count on change.
              $filterInputs.change(function () {
                $count.text($filters.filledInputsCount());
              });
            }
          }
          else {
            $toggle.hide();
          }
        });
      }
    }
  };

  // Checkbox toggle when there is no label wrapper.
  Drupal.behaviors.indiciaCheckboxes = {
    attach: function (context, settings) {
      const $checkboxes = $('input:checkbox');
      if ($checkboxes.length) {
        $checkboxes.each(function () {
          const $checkbox = $(this);
          if (!$checkbox.parents('label').length) {
            $checkbox.siblings('.check').click(function () {
              $checkbox.prop('checked', !$checkbox.prop('checked'));
            });
          }
        });
      }
    }
  };

  Drupal.behaviors.indiciaSelectAllCheckbox = {
    attach: function (context, settings) {
      setTimeout(function () {
        const $selectAll = $('.select-all > input.form-checkbox');
        if ($selectAll.length) {
          const $check = $('<span>').addClass('check');
          $(once('indiciaSelectAllCheckbox', $selectAll.parent())).append($check);

          $check.click(function () {
            $selectAll.prop('checked', !$selectAll.prop('checked'));
          });
        }
      }, 100);
    }
  };

  Drupal.behaviors.indiciaManageColumns = {
    attach: function (context, settings) {
      const $popupHolder = $('.popup-holder');

      if ($popupHolder.length) {
        $(once('indiciaManageColumns', $popupHolder)).each(function () {
          const $popupTrigger = $(this).find('.popup-trigger .count');
          const $popupContent = $(this).find('.popup-content form .fieldset-legend .count');
          const $form = $(this).find('form');

          const updateCount = function (count) {
            $popupTrigger.add($popupContent).text(count);
          };

          // Update count on load.
          updateCount($form.filledInputsCount());

          // Update count on form changes.
          $form.find(':input').change(function () {
            updateCount($form.filledInputsCount());
          });

          $form.find('.select-all').click(function () {
            $(this).parent().find('input:checkbox').prop('checked', true);
            updateCount($form.filledInputsCount());
          });

          $form.find('.unselect-all').click(function () {
            $(this).parent().find('input:checkbox').prop('checked', false);
            updateCount($form.filledInputsCount());
          });
        });
      }
    }
  };

  Drupal.behaviors.indiciaManagedFile = {
    attach: function (context, settings) {
      const $managedFiles = $('.form-type-managed-file');
      if ($managedFiles.length) {
        $managedFiles.each(function () {
          const $currentManagedFile = $(this);
          const countMultiple = $currentManagedFile.find('.form-item.form-type-checkbox').length;
          const $fileInput = $currentManagedFile.find('input.form-file').first();

          // Create upload button.
          const $uploadButton = $('<button>')
            .attr('type', 'button')
            .addClass('upload-button button button--primary-stroked')
            .text(Drupal.t('Add file'));
          $fileInput.hide();
          $(once('indiciaManagedFile', $currentManagedFile)).append($uploadButton);

          $uploadButton.click(function () {
            $fileInput.click();
          });

          if (countMultiple > 0) {
            // Create delete buttons for each file.
            const $deleteButton = $currentManagedFile.find('input[name$="remove_button"]');
            $deleteButton.hide();

            $currentManagedFile.find('.form-item.form-type-checkbox').each(function () {
              const $currentCheckboxWrapper = $(this);
              const $checkbox = $currentCheckboxWrapper.find('input:checkbox');
              const $label = $currentCheckboxWrapper.find('label');

              const $deleteFile = $('<span>').addClass('delete-file icon-cross');
              $(once('indiciaManagedFile', $label)).append($deleteFile);

              $checkbox.change(function () {
                $deleteButton.mousedown();
              });
            });
          } else {
            $currentManagedFile.addClass('single-managed-file');
            const $deleteButton = $currentManagedFile.find('input[name$="remove_button"]');
            $deleteButton.hide();
            const $fileSpan = $currentManagedFile.find('span.file');
            const $deleteFile = $('<span>').addClass('delete-file icon-cross');
            $(once('indiciaManagedFile', $fileSpan)).append($deleteFile);
            $deleteFile.click(function () {
              $deleteButton.mousedown();
            });
          }
        });
      }
    }
  };

  Drupal.behaviors.indiciaFlatpickr = {
    attach: function (context, settings) {
      const $dates = $('input[type="date"]');
      if ($dates.length) {
        $(once('indiciaFlatpickr', $dates)).each(function (index, date) {
          const $date = $(date);
          const options = {
            dateFormat: $date.attr('data-flatpickr-date-format'),
          };

          if ($date.data('min-date')) {
            options['minDate'] = $date.data('min-date');
          }

          if ($date.data('max-date')) {
            options['maxDate'] = $date.data('max-date');
          }

          if ($date.data('flatpickr-default-value')) {
            options['defaultDate'] = $date.data('flatpickr-default-value');
          }

          $date.flatpickr(options);
        });
      }
    }
  };

  Drupal.behaviors.indiciaPagerTableAnchor = {
    attach: function (context, settings) {
      const $anchor = $('.sedico-main-table-anchor', context);
      const $pagerItems = $('.pager a', context);

      if ($anchor.length && $pagerItems.length) {
        $(once('indiciaPagerTableAnchor', $pagerItems)).each(function () {
          $(this).attr('href', $(this).attr('href') + '#' + $anchor.attr('id'));
        });
      }
    }
  };

  Drupal.behaviors.indiciaSelect2 = {
    attach: function (context, settings) {
      const $select = $('select:not([class*=flatpickr])', context);
      if ($select.length) {
        $(once('indiciaSelect2', $select)).each(function () {
          const options = {};
          if ($(this).hasClass('no-search')) {
            options['minimumResultsForSearch'] = 'Infinity';
          }
          $(this).select2(options);
        });
      }
    }
  };

  Drupal.behaviors.indiciaReadOnlyCheckboxes = {
    attach: function (context, settings) {
      const $checkboxes = $('input[type="checkbox"][readonly], input[type="checkbox"].read-only', context);
      if ($checkboxes.length) {
        $(once('indiciaReadOnlyCheckboxes', $checkboxes)).click(function (e) {
          e.preventDefault();
        });
      }
    }
  };

  Drupal.behaviors.indiciaFocusLogin = {
    attach: function (context, settings) {
      const $loginUsername = $('#user-login-form #edit-name', context);
      if ($loginUsername.length) {
        $(once('indiciaFocusLogin', $loginUsername)).focus();
      }

      const $tfaCode = $('#tfa-entry-form #edit-code', context);
      if ($tfaCode.length) {
        $(once('indiciaFocusTfa', $tfaCode)).focus();
      }
    }
  };

})(jQuery, once);
